import addDuration from "date-fns-duration";

/**
 * Sort an array of objects by given key with ISO duration value
 * @param arr
 * @returns
 */
export const sortByDuration = <T, K extends keyof T>(arr: T[], key: K): T[] => {
  const baseDate = new Date();

  return arr.slice().sort((elmnA, elmnB) => {
    const dateA = addDuration(baseDate, String(elmnA[key]));
    const dateB = addDuration(baseDate, String(elmnB[key]));

    if (dateA < dateB) {
      return -1;
    } else if (dateA > dateB) {
      return 1;
    }

    return 0;
  });
};

/**
 * Sort an array of objects by passed property key name
 * @param arr
 * @returns
 */
export const sortByKey = <T, K extends keyof T>(arr: T[], key: K): T[] => {
  return arr.slice().sort((elmnA: T, elmnB: T) => {
    const valueA = elmnA[key];
    const valueB = elmnB[key];

    if (valueA < valueB) {
      return -1;
    } else if (valueA > valueB) {
      return 1;
    }

    return 0;
  });
};
